module.exports = __webpack_public_path__ + "static/img/11f.f163635.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11f.jpg
// module id = zynN
// module chunks = 0